import * as Urql from 'urql';
import gql from 'graphql-tag';

import * as Types from '../../types/api.generated';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type EntryRuleFragment = {
    __typename?: 'EntryRulesOutput';
    id?: string;
    name?: string;
    active?: boolean;
    description?: string;
    gameMode: Types.GameMode;
    gameType: Types.GameType;
    minNumberOfPicks: number;
    minNumberOfTeams: number;
    maxNumberOfPicks: number;
    maxNumberOfPicksForType: Array<{ __typename?: 'MaxPicksForType'; type: Types.ProjectionType; maxPicks: number }>;
};

export type MaxPicksPerTypeFragment = { __typename?: 'MaxPicksForType'; type: Types.ProjectionType; maxPicks: number };

export type GetEntryAndFeedConfigsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetEntryAndFeedConfigsQuery = {
    __typename?: 'Query';
    getAllEntryRules?: Array<{
        __typename?: 'EntryRulesOutput';
        id?: string;
        name?: string;
        active?: boolean;
        description?: string;
        gameMode: Types.GameMode;
        gameType: Types.GameType;
        minNumberOfPicks: number;
        minNumberOfTeams: number;
        maxNumberOfPicks: number;
        maxNumberOfPicksForType: Array<{
            __typename?: 'MaxPicksForType';
            type: Types.ProjectionType;
            maxPicks: number;
        }>;
    }>;
    getEntryFeedConfig: { __typename?: 'EntryFeedConfig'; socialFeedEnabled: boolean; raceToPlaceEnabled: boolean };
};

export const MaxPicksPerTypeFragmentDoc = gql`
    fragment MaxPicksPerType on MaxPicksForType {
        type
        maxPicks
    }
`;
export const EntryRuleFragmentDoc = gql`
    fragment EntryRule on EntryRulesOutput {
        id
        name
        active
        description
        gameMode
        gameType
        minNumberOfPicks
        minNumberOfTeams
        maxNumberOfPicks
        maxNumberOfPicksForType {
            ...MaxPicksPerType
        }
    }
    ${MaxPicksPerTypeFragmentDoc}
`;
export const GetEntryAndFeedConfigsDocument = gql`
    query GetEntryAndFeedConfigs {
        getAllEntryRules {
            ...EntryRule
        }
        getEntryFeedConfig {
            socialFeedEnabled
            raceToPlaceEnabled
        }
    }
    ${EntryRuleFragmentDoc}
`;

export function useGetEntryAndFeedConfigsQuery(
    options?: Omit<Urql.UseQueryArgs<GetEntryAndFeedConfigsQueryVariables>, 'query'>
) {
    return Urql.useQuery<GetEntryAndFeedConfigsQuery, GetEntryAndFeedConfigsQueryVariables>({
        query: GetEntryAndFeedConfigsDocument,
        ...options,
    });
}
